import React, { useState } from "react";

import "./styles.css";

import { Link } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../../../services/api";
import { TagsDisplay } from "../../UiComponents";
import LocalizationContext from "../../../../localization/LocalizationContext";
import ReactHtmlParser from "react-html-parser";
import { formatDate } from "../../../helper/formatDate";

export default function HomeSection4(props) {
  const { t } = React.useContext(LocalizationContext);

  const { data, isLoading, error } = props.queryData;
  const triangleArticle = props.triangleArticle;
  const fallbackArtistInResidence = props.fallbackQueryData?.data ? props.fallbackQueryData?.data : null;
  const appLanguage = props.appLanguage;
  const currentArtist = data?.length ? data[0] : null;
  const [showHoverEffect, setShowHoverEffect] = useState(false)

  let fallbackImage = fallbackArtistInResidence?.frontPageFallbackPicture?.url || null,
    fallbackTitle = null,
    fallbackDescription = null;

  if (fallbackArtistInResidence) {
    if (appLanguage == "no") {
      fallbackTitle = fallbackArtistInResidence?.nor_frontpage_fallback_title;
      fallbackDescription = fallbackArtistInResidence?.nor_frontpage_fallback_description;
    } else {
      fallbackTitle = fallbackArtistInResidence?.eng_frontpage_fallback_title;
      fallbackDescription = fallbackArtistInResidence?.eng_frontpage_fallback_description;
    }
  }

  const onHoverStyleImage = {
    opacity: 0.8
  }
  const onMouseHoverHeadingOrImage = () => {
    setShowHoverEffect(true)
  }
  const onMouseRemoveHeadingOrImage = () => {
    setShowHoverEffect(false)
  }

  const renderFallbackColumn1 = () => {
    return <div className="flexGrow paddedRightSm">
      <p className="artistinresidencysection1__title-one text-fabric-sans">
      {t("Artist In Residency")}
      </p>
      <div>
        {(!!fallbackImage) && <Link to={`/artistinresidency`}>

          <img src={`${IMAGE_BASE_URL}${fallbackImage}`}
            style={showHoverEffect ? { ...onHoverStyleImage } : null}
            onMouseOver={onMouseHoverHeadingOrImage}
            onMouseOut={onMouseRemoveHeadingOrImage}
          />
        </Link>}
        <div className="homesection1__bottom-container">
          <Link to={`/artistinresidency`}>
            <p className="trianglesection4__content-title fs-2-5em lh-1-2em"
            >
              {ReactHtmlParser(fallbackTitle || "")}
            </p>
          </Link>
          <p className="trianglesection4__content-text fs-1-2em lh-1-4em">
            {ReactHtmlParser(fallbackDescription || "")}
          </p>
        </div>
      </div>
    </div>
  }

  const renderColumn1 = () => (
    currentArtist ? (
      <div className="homesection4__content flexGrow paddedRightSm">
        <p className="artistinresidencysection1__title-one text-fabric-sans ">
          {t("Artist In Residency")}
        </p>
        <div className="homesection4__image">
          <Link to={`/artistprofile/${currentArtist.id}`}>
            {currentArtist.profileImg && (
              <img src={`${IMAGE_BASE_URL}${currentArtist.profileImg.url}`} />
            )}
          </Link>
        </div>
        <div className="homesection4__info-text">
          <p className="homesection4__text-line1">
            {formatDate(currentArtist.dateStart)} - {formatDate(currentArtist.dateEnd)}
          </p>
          <Link to={`/artistprofile/${currentArtist.id}`}>
            <p className="homesection4__text-line2 fs-5-5em">
              {currentArtist.name}
            </p>
          </Link>
        </div>
        <div style={{ margin: "15px" }}></div>
        <TagsDisplay tagList={currentArtist.tags} />
      </div>
    ) : renderFallbackColumn1()
  );

  const renderColumn2 = () => {
    return <div className="flexGrow paddedLeftSm">
      <p className="artistinresidencysection1__title-one text-fabric-sans">
        {t("Triangle")}
      </p>
      <div>
        <Link to={`/triangle/${triangleArticle.id}`}>

          <img src={`${IMAGE_BASE_URL}${triangleArticle?.mainImage?.url}`}
            style={showHoverEffect ? { ...onHoverStyleImage } : null}
            onMouseOver={onMouseHoverHeadingOrImage}
            onMouseOut={onMouseRemoveHeadingOrImage}
          />
        </Link>
        <div className="homesection1__bottom-container">
          <Link to={`/triangle/${triangleArticle.id}`}>
            <p className="trianglesection4__content-title fs-2-5em lh-1-2em"
            >
              {triangleArticle?.title}
            </p>
          </Link>

          <p className="trianglesection4__content-text fs-1-2em lh-1-4em">
            {triangleArticle?.shortDescription}
          </p>

          <TagsDisplay tagList={triangleArticle?.tags || []} />
        </div>
      </div>
    </div>
  }


  return (
    <div className="homesection4__container flex row">
      {renderColumn1()}
      {renderColumn2()}
    </div>
  );
}

